<div class="form-group row margin-top-2 text-center item-center mb-0 pb-0">
    <div class="col-lg-12 mb-0 multimedia-header">
        <h5 class="my-3 text-black" *ngIf="hasTitle">Accommodation Layout</h5>
    </div>
</div>
<div class="mat-table-wrapper" [ngClass]="{'readonly': readonly}">
    <table class="table">
        <thead>
            <th colspan="5">Items</th>
            <th class="h-cell" *ngFor="let floor of floors">
                <ng-container *ngIf="schemeId == 1">
                    <span *ngIf="floor < 0">
                        Lower Ground ({{floor}})
                    </span>
                    <span *ngIf="floor == 0">
                        Ground
                    </span>
                    <span *ngIf="floor > 0">
                        Floor {{floor}}
                    </span>
                </ng-container>
                <ng-container *ngIf="schemeId == 2">
                    <span *ngIf="floor < 0">
                        Lower Ground ({{floor}}) 
                    </span>
                    <span *ngIf="floor == 1">
                        Floor 1 (Ground) 
                    </span>
                    <span *ngIf="floor > 1">
                        Floor {{floor}}
                    </span>
                </ng-container>
            </th>
        </thead>
        <tbody>
            <ng-container *ngIf="tableRows.kind === 'default'">
                <tr *ngFor="let row of tableRows.rows; let i = index" [ngClass]="{'gray': i%2}">
                    <th class="row-header" colspan="5">
                        <input type="text"
                            class="title-input w-100"
                            [ngModel]="titles[row.key] ?? row.title"
                            (ngModelChange)="titles[row.key] = $event"
                            (blur)="onTitleBlur(row.key)" />
                    </th>
                    <td *ngFor="let floor of floors">
                        <span>
                            <input mask="0000"
                                class="title-input"
                                type="text"
                                (change)="onChange($event, row.key)"
                                [(ngModel)]="data[floor][row.key]" >
                        </span>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="tableRows.kind === 'special'">
                <ng-container *ngFor="let row of tableRows.rows">
                    <ng-container *ngIf="row.subrows.length === 0">
                        <tr>
                            <th class="row-header" colspan="5">
                                <span class="d-flex align-items-center" style="gap: 1rem">
                                    <input type="text"
                                        class="title-input flex-grow-1"
                                        [ngModel]="titles[row.key] ?? row.category"
                                        (ngModelChange)="titles[row.key] = $event"
                                        (blur)="onTitleBlur(row.key)" />
                                    <mat-icon *ngIf="row.tooltip" container="body" [ngbPopover]="row.tooltip" style="cursor: pointer">
                                        help
                                    </mat-icon>
                                </span>
                            </th>
                            <td *ngFor="let floor of floors">
                                <span>
                                    <input mask="0000"
                                        class="title-input"
                                        type="text"
                                        (change)="onChange($event, row.key)"
                                        [(ngModel)]="data[floor][row.key]" >
                                </span>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-container *ngIf="row.subrows.length !== 0">
                        <tr *ngFor="let subRow of row.subrows; let i = index">
                            <th *ngIf="i == 0" class="vertical-row-header" colspan="1" [attr.rowspan]="row.subrows.length">
                                <span>
                                    {{ row.category }}

                                </span>
                            </th>
                            <th class="row-header" colspan="4">
                                <span class="d-flex align-items-center" style="gap: 1rem">
                                    <input type="text"
                                        class="title-input flex-grow-1"
                                        [ngModel]="titles[subRow.key] ?? subRow.title"
                                        (ngModelChange)="titles[subRow.key] = $event"
                                        (blur)="onTitleBlur(subRow.key)" />
                                    <mat-icon *ngIf="subRow.tooltip" container="body" [ngbPopover]="subRow.tooltip" style="cursor: pointer">
                                        help
                                    </mat-icon>
                                </span>
                            </th>
                            <td *ngFor="let floor of floors">
                                <span>
                                    <input mask="0000"
                                        class="title-input"
                                        type="text"
                                        (change)="onChange($event, subRow.key)"
                                        [(ngModel)]="data[floor][subRow.key]" >
                                </span>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </ng-container>
            <tr *ngFor="let other of others; let i = index" [ngClass]="{'gray': i%2==1}">
                <th class="other-header" colspan="2">Other ({{i + 1}})</th>
                <th class="other-input" [attr.colspan]="i == 0 ? 2 : 1">
                    <input type="text" class="title-input" [value]="other" [(ngModel)]="other.title" />
                </th>
                <th  class="row-header btn-cell" style="text-align: center;" *ngIf="i > 0" >
                    <button mat-icon-button type="button" [disabled]="readonly" (click)="removeOther(i, other.id)">
                        <mat-icon color="warn">remove_circle</mat-icon>
                    </button>
                </th>
                <th  class="row-header btn-cell" style="text-align: center;">
                    <button mat-icon-button type="button" [disabled]="readonly" (click)="addOther(i)">
                        <mat-icon style="color: green;">add_circle</mat-icon>
                    </button>
                </th>
                <td *ngFor="let floor of floors">
                    <span><input type="text" mask="0000" class="title-input" [(ngModel)]="data[floor][other.id]"></span>
                </td>
            </tr>
        </tbody>
    </table>
</div>